module.exports = __webpack_public_path__ + "plugins/web/img/1.7cde8d15.png";